import React from 'react';
import './App.css';

function App() {
    return (
        <div className="container">
            <div className="message">
                <h1>没钱了 开摆</h1>
                <h2>降本增效 这破玩意一个月自己贴钱就要200RMB 还要被人说不好用😡</h2>
                <h2>充不起会员和服务器了 以后有钱再充</h2>
            </div>
        </div>
    );
}

export default App;